import React from 'react';
import { FileInput, FileInputProps, fileUtils } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { localizationStore } from '@stores/localization';
import {
  FILE_VALIDATION_OPTIONS,
  getFileErrorTranslation,
  MAX_FILE_COUNT,
} from '@utils/file.utils';

export const OmaSATOFileInput = observer(
  ({
    label,
    message,
    value,
    error,
    maxItems,
    ...rest
  }: Partial<FileInputProps>) => {
    const t = localizationStore.getTranslation;

    return (
      <FileInput
        {...rest}
        label={label ?? t('choose_files')}
        message={message ?? t('upload_files_helper')}
        getFileError={(file) => {
          const error = fileUtils.getFileError(file, FILE_VALIDATION_OPTIONS);
          return getFileErrorTranslation({
            error,
            translationGetter: t,
          });
        }}
        value={value}
        error={error}
        maxItems={maxItems ?? MAX_FILE_COUNT}
        compressImages
      />
    );
  }
);
